const getCityUrlDomain = (store) => {
	return store.Session.params?.town;
};

export default getCityUrlDomain;
